"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachedFileList = exports.AttachedFileListSubComponent = void 0;
const react_1 = __importStar(require("react"));
const AttachedFileListContext_1 = require("./AttachedFileListContext");
var AttachedFileListSubComponent;
(function (AttachedFileListSubComponent) {
    AttachedFileListSubComponent["Errors"] = "Errors";
    AttachedFileListSubComponent["Info"] = "Info";
    AttachedFileListSubComponent["Rows"] = "Rows";
})(AttachedFileListSubComponent || (exports.AttachedFileListSubComponent = AttachedFileListSubComponent = {}));
// List of all the sub-components needed to be nested in an AttachedFileList
// We need these as otherwise the UX for a file list is incomplete, e.g. we need
// to show errors, we need to show how many files are left etc.
const neededSubComponents = [
    AttachedFileListSubComponent.Errors,
    AttachedFileListSubComponent.Rows,
    AttachedFileListSubComponent.Info,
];
const AttachedFileList = ({ children, }) => {
    // track the sub-components - we want all the correct ones in here
    const subComponents = (0, react_1.useRef)([]);
    // Check that everything is as we expect - the all sub-components are present
    (0, react_1.useEffect)(() => {
        if (!neededSubComponents.every((v) => subComponents.current.includes(v))) {
            throw new Error("Need to have all sub-components nested under AttachedFileList - Errors, Info, Rows");
        }
    }, [subComponents.current]);
    const registerSubComponent = (0, react_1.useCallback)((component) => {
        if (component && subComponents.current.indexOf(component) === -1) {
            subComponents.current.push(component);
        }
    }, []);
    return (react_1.default.createElement(AttachedFileListContext_1.AttachedFileListProvider, { value: { registerSubComponent } }, children));
};
exports.AttachedFileList = AttachedFileList;
//# sourceMappingURL=AttachedFileList.js.map